/**
 * Notification Entity
 * Represents a notification in the dashboard
 */
export interface NotificationProps {
  id: string;
  message: string;
  time: string;
  isRead?: boolean;
  readAt?: string | null;
  scopeType?: string;
}

export class Notification {
  private readonly props: NotificationProps;

  constructor(props: NotificationProps) {
    this.props = props;
  }

  get id(): string {
    return this.props.id;
  }

  get message(): string {
    return this.props.message;
  }

  get time(): string {
    return this.props.time;
  }

  get isRead(): boolean {
    return this.props.isRead ?? false;
  }

  get readAt(): string | null {
    return this.props.readAt ?? null;
  }

  get scopeType(): string | undefined {
    return this.props.scopeType;
  }

  toPlainObject(): NotificationProps {
    return { ...this.props };
  }
}
